export default __webpack_public_path__ + "static/media/wegovy-check-flow.59b55771.mp4";